import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Colors, Typography } from '../../shared/theme/styles.enum';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tab: {
      fontFamily: Typography.FontFamily2,
      fontSize: '1.25rem',
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1,
      letterSpacing: 'normal',
      textAlign: 'center',
      color: Colors.TextGray,
      textTransform: 'capitalize',
      margin: '0 20px',
      paddingLeft: 0,
      paddingRight: 0,
      '@media (max-width:768px)': {
        minWidth: 'unset',
        margin: 0,
        padding: '6px 12px',
        flex: 1,
      },
    },
    active: {
      color: theme.palette.primary.main,
      background: theme.palette.primary.main,
    },
    activeLabel: {
      fontFamily: Typography.FontFamily2,
      fontSize: '0.875rem',
      fontWeight: 600,
      color: theme.palette.primary.main,
      textAlign: 'center',
      padding: '8px 0 0',
    },
  })
);
